<form [formGroup]="plasticsForm">
  <h1>{{ translationService.getProductPlasticsDeclarationText() }}</h1>

  <mat-form-field class="input-sm" appearance="outline">
    <mat-label>{{
      translationService.getProductMaterialTypeLabel()
    }}</mat-label>
    <mat-select formControlName="productMaterialType">
      <mat-option value="RawResin">
        {{ translationService.getProductMaterialTypeRawResinText() }}
      </mat-option>
      <mat-option value="PlasticProduct">
        {{ translationService.getProductMaterialTypePlasticProductText() }}
      </mat-option>
      <mat-option value="NonPlastic">
        {{ translationService.getProductMaterialTypeNonPlasticText() }}
      </mat-option>
      <mat-option value="Undeclared">
        {{ translationService.getProductMaterialTypeUndeclaredText() }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="custom-form-row">
    <mat-form-field class="input-md" appearance="outline">
      <mat-label>{{ translationService.getTagsText() }}</mat-label>
      <mat-chip-grid
        #tagGrid
        [attr.aria-label]="translationService.getTagsText()"
      >
        @for (tagCtrl of tagsArray.controls; track tagCtrl; let i = $index) {
          <mat-chip-row (removed)="removeTag(i)">
            {{ tagCtrl.value }}
            <button
              matChipRemove
              type="button"
              [attr.aria-label]="translationService.getRemoveTagText()"
            >
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input
        [matChipInputFor]="tagGrid"
        [matChipInputSeparatorKeyCodes]="tagSeparatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addTag($event)"
        [placeholder]="translationService.getAddTagPlaceholderText()"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        [matTooltip]="translationService.getProductTagsTooltipText()"
        [attr.aria-label]="translationService.getAboutProductTagsText()"
      >
        <mat-icon>info</mat-icon>
      </button>
      <mat-hint>
        {{ translationService.getProductTagsHintText() }}
      </mat-hint>
    </mat-form-field>
  </div>

  @if (hasMaterialType()) {
    @if (isNonPlastic() || isUndeclared()) {
    } @else {
      @if (!isPlasticProduct()) {
        <!-- RESIN PRODUCT -->
        <div class="custom-form-row">
          <mat-form-field class="input-sm" appearance="outline">
            <mat-label>{{
              translationService.getProductWeightKgText()
            }}</mat-label>
            <input
              matInput
              type="number"
              name="productWeightKg"
              formControlName="productWeightKg"
              autocomplete="off"
              min="0"
            />
          </mat-form-field>

          <mat-form-field class="input-md" appearance="outline">
            <mat-label>{{ translationService.getNAPCSTypeText() }}</mat-label>
            <mat-select formControlName="napcsCodeId">
              @for (code of napcsCodes; track code) {
                <mat-option [value]="code.id">
                  {{ code.fullResinTitle }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="input-sm" appearance="outline">
            <mat-label>{{ translationService.getSourceTypeText() }}</mat-label>
            <mat-select formControlName="sourceType">
              @for (opt of SOURCE_TYPES | keyvalue; track opt.key) {
                <mat-option [value]="opt.key">{{ opt.value }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="custom-form-row">
          <mat-form-field class="input-md" appearance="outline">
            <mat-label>
              {{ translationService.getReportingDateText() }}
              <mat-icon
                [matTooltip]="translationService.getReportingDateTooltipText()"
                class="info-icon"
                inline
                >info</mat-icon
              >
            </mat-label>
            <input
              matInput
              [matDatepicker]="reportingDatePicker"
              formControlName="reportingDate"
              name="reportingDate"
              autocomplete="off"
              [max]="maxReportingDate"
            />
            <mat-datepicker-toggle matSuffix [for]="reportingDatePicker" />
            <mat-datepicker #reportingDatePicker />
          </mat-form-field>

          <mat-form-field class="input-md" appearance="outline">
            <mat-label>{{ translationService.getSupplierText() }}</mat-label>
            <input
              matInput
              name="supplier"
              formControlName="supplier"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
      } @else {
        <!-- PLASTIC PRODUCT -->
        <div class="custom-form-row">
          <mat-form-field class="input-md" appearance="outline">
            <mat-label>
              {{ translationService.getReportingDateText() }}
              <mat-icon
                [matTooltip]="translationService.getReportingDateTooltipText()"
                class="info-icon"
                inline
                >info</mat-icon
              >
            </mat-label>
            <input
              matInput
              [matDatepicker]="reportingDatePickerPlastic"
              formControlName="reportingDate"
              name="reportingDate"
              autocomplete="off"
              [max]="maxReportingDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="reportingDatePickerPlastic"
            />
            <mat-datepicker #reportingDatePickerPlastic />
          </mat-form-field>

          <mat-form-field class="input-md" appearance="outline">
            <mat-label>{{ translationService.getSupplierText() }}</mat-label>
            <input
              matInput
              name="supplier"
              formControlName="supplier"
              autocomplete="off"
            />
          </mat-form-field>
        </div>

        <div class="custom-form-row">
          <mat-form-field class="input-md" appearance="outline">
            <mat-label>{{ translationService.getCategoryText() }}</mat-label>
            <mat-select formControlName="category">
              @for (opt of activeCategories | keyvalue; track opt.key) {
                <mat-option [value]="opt.key">{{ opt.value }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="input-md" appearance="outline">
            <mat-label>{{ translationService.getSubcategoryText() }}</mat-label>
            <mat-select formControlName="subcategory">
              @for (
                opt of subcategoriesForSelectedCategory | keyvalue;
                track opt.key
              ) {
                <mat-option [value]="opt.key">{{ opt.value }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="custom-form-row">
          <mat-form-field class="input-md" appearance="outline">
            <mat-label>{{
              translationService.getCalculationMethodText()
            }}</mat-label>
            <mat-select formControlName="calculationMethod">
              @for (opt of CALCULATION_METHODS | keyvalue; track opt.key) {
                <mat-option [value]="opt.key">{{ opt.value }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (plasticsForm.value.calculationMethod === 'Other') {
            <mat-form-field class="input-md" appearance="outline">
              <mat-label>{{
                translationService.getCalculationMethodOtherText()
              }}</mat-label>
              <input
                matInput
                name="calculationMethodOther"
                formControlName="calculationMethodOther"
                autocomplete="off"
              />
            </mat-form-field>
          }
        </div>

        <div class="custom-form-row">
          <div class="waste-streams-radio-group margin-left-10">
            <mat-radio-group formControlName="wasteStream">
              <mat-label class="margin-left-10"
                >{{ translationService.getSelectWasteStreamsText() }} *
              </mat-label>
              <mat-radio-button
                [value]="WASTE_STREAM_VALUES.RESIDENTIAL"
                class="waste-stream-radio"
              >
                {{ WASTE_STREAM_LABELS.residential }}
              </mat-radio-button>
              <mat-radio-button
                [value]="WASTE_STREAM_VALUES.ICI"
                class="waste-stream-radio"
              >
                {{ WASTE_STREAM_LABELS.ici }}
              </mat-radio-button>
              <mat-radio-button
                [value]="WASTE_STREAM_VALUES.CDR"
                class="waste-stream-radio"
              >
                {{ WASTE_STREAM_LABELS.cdr }}
              </mat-radio-button>
              @if (
                plasticsForm.get('wasteStream')?.touched &&
                plasticsForm.get('wasteStream')?.invalid
              ) {
                <mat-error>
                  {{ translationService.getSelectWasteStreamMessage() }}
                </mat-error>
              }
            </mat-radio-group>
          </div>
        </div>

        <app-plastic-resin
          [resins]="plasticResins"
          [napcsCodes]="napcsCodes"
          [sourceTypes]="SOURCE_TYPES"
        ></app-plastic-resin>
      }
    }
  }
</form>

<div>
  <div class="actions margin-top-10">
    <button
      mat-raised-button
      extended
      color="primary"
      class="action-item"
      (click)="onSubmit()"
    >
      <mat-icon>add</mat-icon>
      {{ translationService.getSubmitText() }}
    </button>
    <button
      mat-raised-button
      extended
      color="primary"
      class="action-item"
      (click)="goBack()"
    >
      <mat-icon>arrow_back</mat-icon>
      {{ translationService.getBackText() }}
    </button>
    <button
      type="button"
      mat-stroked-button
      extended
      color="primary"
      class="action-item"
      (click)="onReset()"
    >
      <mat-icon>refresh</mat-icon>
      {{ translationService.getResetText() }}
    </button>
  </div>
</div>
